import { ArrowRight } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Checkbox } from "@/components/ui/checkbox";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import { useI18n } from "@/i18n";

function Field({ label, children }) {
  return (
    <div>
      <label className="text-sm font-semibold text-[#1a2d56] mb-1.5 block">{label}</label>
      {children}
    </div>
  );
}

export function ContactForm({ contact, setContact, consent, setConsent, onStart }) {
  const { t } = useI18n();
  return (
    <div className="mt-8 space-y-4" data-testid="contact-form">
      <div className="grid sm:grid-cols-2 gap-4">
        <Field label={t("field_first")}>
          <Input data-testid="input-first-name" value={contact.first_name}
            onChange={(e) => setContact({ ...contact, first_name: e.target.value })}
            placeholder={t("ph_first")} className="rounded-xl py-6" />
        </Field>
        <Field label={t("field_last")}>
          <Input data-testid="input-last-name" value={contact.last_name}
            onChange={(e) => setContact({ ...contact, last_name: e.target.value })}
            placeholder={t("ph_last")} className="rounded-xl py-6" />
        </Field>
      </div>
      <Field label={t("field_email")}>
        <Input data-testid="input-email" type="email" value={contact.email}
          onChange={(e) => setContact({ ...contact, email: e.target.value })}
          placeholder={t("ph_email")} className="rounded-xl py-6" />
      </Field>
      <div className="grid sm:grid-cols-2 gap-4">
        <Field label={t("field_phone")}>
          <Input data-testid="input-phone" value={contact.phone}
            onChange={(e) => setContact({ ...contact, phone: e.target.value })}
            placeholder={t("ph_phone")} className="rounded-xl py-6" />
        </Field>
        <Field label={t("field_postal")}>
          <Input data-testid="input-postal" value={contact.postal_code}
            onChange={(e) => setContact({ ...contact, postal_code: e.target.value })}
            placeholder={t("ph_postal")} className="rounded-xl py-6" />
        </Field>
      </div>

      <Field label={t("member_label")}>
        <Select value={contact.member_status || undefined}
          onValueChange={(v) => setContact({ ...contact, member_status: v })}>
          <SelectTrigger data-testid="input-member-status" className="rounded-xl py-6">
            <SelectValue placeholder={t("member_placeholder")} />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="current" data-testid="member-current">{t("member_current")}</SelectItem>
            <SelectItem value="past" data-testid="member-past">{t("member_past")}</SelectItem>
            <SelectItem value="never" data-testid="member-never">{t("member_never")}</SelectItem>
          </SelectContent>
        </Select>
      </Field>

      <label className="flex items-start gap-3 cursor-pointer mt-2" data-testid="recontact-checkbox">
        <Checkbox checked={contact.recontact_ok}
          onCheckedChange={(v) => setContact({ ...contact, recontact_ok: !!v })}
          className="mt-0.5" />
        <span className="text-sm text-[#4b5b7c]">{t("recontact_label")}</span>
      </label>

      <label className="flex items-start gap-3 cursor-pointer rounded-2xl bg-white border border-[#e2e8f0] p-4" data-testid="consent-checkbox">
        <Checkbox checked={consent} onCheckedChange={(v) => setConsent(!!v)} className="mt-0.5" />
        <span className="text-sm text-[#4b5b7c] leading-relaxed">{t("consent_label")}</span>
      </label>

      <p className="text-xs text-[#9aa6c0] leading-relaxed -mt-1" data-testid="consent-privacy-note">
        {t("consent_privacy")}{" "}
        <a href="/confidentialite" target="_blank" rel="noopener noreferrer"
           className="underline hover:text-[#1a2d56]">{t("privacy_policy")}</a>
      </p>

      <button
        data-testid="start-questionnaire-button"
        onClick={onStart}
        className="w-full inline-flex items-center justify-center gap-2 bg-[#1a2d56] text-white font-head font-bold rounded-full px-8 py-4 transition-all duration-300 hover:-translate-y-0.5 hover:shadow-xl"
      >
        {t("start_btn")} <ArrowRight size={18} />
      </button>
    </div>
  );
}
